import React from "react";

import { FaChevronUp, FaChevronDown } from "react-icons/fa6";

import { LiaFilterSolid } from "react-icons/lia";

import "./styles.scss";

const ManageFilters = ({ handleShowFiltersSection, showFilters, title, customStyle }) => {
    return (
        <div className="filters-manage-section" onClick={handleShowFiltersSection} style={customStyle}>
            <div className="icon-section"><LiaFilterSolid /></div>
            <div className="line-section" />
            <div className="text-section">{title || "Filters"}</div>
            <div className="line-section" />
            <div className="icon-section">{showFilters ? <FaChevronUp /> : <FaChevronDown />}</div>
        </div>
    )
}

export default ManageFilters